export default __webpack_public_path__ + "static/media/IMG-20241005-WA0028.743590f3.jpg";